import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { getDynamicImage, SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import Style from './CastMember.module.scss';

const CastInitials = info => {
  let initials = '';
  if (info.name) {
    initials = info.name.match(/\b\w/g) || [];
    initials = initials.join('').toUpperCase();
  }

  return (
    <div className={Style.missingCastImage}>
      <div className={Style.castInitials}>{initials}</div>
    </div>
  );
};

const CastMember = ({
  breakpoint,
  disableScroll,
  index,
  info,
  isCast = true,
  opensOverlay = false,
  setCastDetail,
  showCode,
}) => {
  const imageUrl = _.get(info, 'images.bioDetail');
  const bioAltText = _.get(info, 'images.altText', '');
  const dynamicImageUrl = getDynamicImage({
    breakpoint,
    context: SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE,
    url: imageUrl,
  });
  const image = imageUrl ? (
    <img className={Style.castImage} src={dynamicImageUrl} alt={bioAltText} />
  ) : (
    CastInitials(info)
  );
  const onClick = () => {
    if (setCastDetail) setCastDetail({ info, index });
    disableScroll({ disableScroll: true, bodyOnly: true });
  };
  const imageClass = imageUrl ? Style.imageButton : Style.missingImageButton;
  const imageButton = image => (
    <button className={imageClass} onClick={onClick} type="button" aria-label="Cast Picture">
      {image}
    </button>
  );

  const imageLink = image => (
    <Link
      className={imageClass}
      to={`/${showCode}/${isCast ? 'credits' : 'characters'}/${info.alternateId}/`}
      onlyActiveOnIndex
    >
      {image}
    </Link>
  );

  return (
    <div
      className={classNames(Style.castMemberContainer, opensOverlay && Style.carouselCastMember)}
    >
      {opensOverlay ? imageButton(image) : imageLink(image)}
      <div className={Style.castNamesContainer}>
        <a onClick={onClick}>
          <div className={Style.actorName}>{info.name}</div>
        </a>
        {info.characterName && <div className={Style.characterName}>{info.characterName}</div>}
      </div>
    </div>
  );
};

CastMember.propTypes = {
  breakpoint: PropTypes.string,
  disableScroll: PropTypes.func,
  index: PropTypes.number,
  info: PropTypes.shape({}),
  isCast: PropTypes.bool,
  opensOverlay: PropTypes.bool,
  setCastDetail: PropTypes.func,
  showCode: PropTypes.string,
};

export default CastMember;
